import React, { useState } from "react";
import moment from "moment";
import {
  ActionBar,
  Column,
  Container,
  Heading,
  Loader,
  Row,
  BadRequestError,
  formatNumber,
  isNotFoundError,
  isNothing,
  parseIntlNumber,
  withApi,
  withBrowser,
  withIntl,
  withNotifier,
  withUser,
  apiShape,
  browserShape,
  intlShape,
  notifierShape,
  userShape,
} from "lcm-iot-commons";
import TaxForm from "./TaxForm";

type TaxEditProps = {
  api: apiShape;
  browser: browserShape;
  intl: intlShape;
  notifier: notifierShape;
  match: {
    params?: {
      id?: string;
    };
  };
  user: userShape;
};

export function TaxEdit({
  api,
  browser,
  intl,
  notifier,
  match,
  user,
}: TaxEditProps) {
  const [tax, setTax] = useState();

  const loadTax = async () => {
    try {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      const response = await api.get(`/taxes/${match.params.id}`);
      const taxItem = {
        type: { id: response.type },
        rate: formatNumber(response.rate),
        startDate: new Date(response.start_date),
        endDate: response.end_date ? new Date(response.end_date) : null,
        country: { code: response.country_code.toUpperCase() },
      };
      // @ts-expect-error TS(2345) FIXME: Argument of type '{ type: { id: any; }; rate: stri... Remove this comment to see the full error message
      setTax(taxItem);
    } catch (error) {
      if (isNotFoundError(error)) {
        browser.navigateTo("/404");
      }
      notifier.showError(api.translateError(error));
    }
  };

  React.useEffect(() => {
    const controllingDirector = (user as $TSFixMe)?.userRoles?.find(
      (ur: $TSFixMe) => ur.name === "controlling_director",
    );
    if (user && isNothing(controllingDirector)) {
      browser.navigateTo("/403");
    } else {
      loadTax();
    }
  }, [match]);

  const handleOnSubmit = async (values: $TSFixMe, actions: $TSFixMe) => {
    try {
      const editTax = {
        type: values.type.id,
        rate: parseIntlNumber(values.rate),
        start_date: moment(values.startDate).format("YYYY-MM-DD"),
        end_date: values.endDate
          ? moment(values.endDate).format("YYYY-MM-DD")
          : null,
        country_code: values.country.code,
      };
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      await api.patch(`/taxes/${match.params.id}`, editTax);
      notifier.showSuccess(
        intl.formatMessage({ id: "tax_edit.success_notification" }),
      );
      actions.resetForm({ values });
      browser.navigateTo("/taxes");
    } catch (error) {
      if (
        error instanceof BadRequestError &&
        // @ts-expect-error TS(2345) FIXME: Argument of type '"start_date"' is not assignable ... Remove this comment to see the full error message
        error.contains("overlap", "start_date")
      ) {
        actions.setErrors({
          endDate: intl.formatMessage({ id: "api.error.taxes_overlap" }),
          startDate: intl.formatMessage({ id: "api.error.taxes_overlap" }),
        });
      } else {
        notifier.showError(api.translateError(error));
      }
    } finally {
      actions.setSubmitting(false);
    }
  };

  const header = (
    <Row>
      <Column>
        <ActionBar>
          <Heading title={intl.formatMessage({ id: "tax_edit.header" })} />
        </ActionBar>
      </Column>
    </Row>
  );

  const editForm = tax ? (
    <Row>
      <Column>
        <TaxForm onSubmit={handleOnSubmit} initialValues={tax} />
      </Column>
    </Row>
  ) : null;

  return user ? (
    <Loader loading={!tax}>
      <Container>
        {header}
        {editForm}
      </Container>
    </Loader>
  ) : null;
}

export default withUser(withApi(withBrowser(withNotifier(withIntl(TaxEdit)))));
